import type { BetSelection } from "@/features/betslip/types";
import type { ToggleSelectionInput } from "@/features/betslip/builders/types";
import {
  buildMatchSelection,
  buildOutrightSelection,
} from "@/features/betslip/builders/sports";
import { buildRaceSelection } from "@/features/betslip/builders/race";
import { buildSemSelection } from "@/features/betslip/builders/sem";
import { buildExoticSelection } from "@/features/betslip/builders/exotic";
import { buildQuaddieSelection } from "@/features/betslip/builders/quaddie";

/**
 * Routes the strictly-typed input to its kind-specific builder.
 */
export const buildSelection = (input: ToggleSelectionInput): BetSelection => {
  switch (input.kind) {
    case "match":
      return buildMatchSelection(input);
    case "outright":
      return buildOutrightSelection(input);
    case "race":
      return buildRaceSelection(input);
    case "sem":
      return buildSemSelection(input);
    case "exotic":
      return buildExoticSelection(input);
    case "quaddie":
      return buildQuaddieSelection(input);
  }
};
